const FINGERPRINT_KEY = 'manejai_device_fingerprint';
const TRUST_DEVICE_KEY = 'manejai_trust_device';
const REMEMBERED_EMAIL_KEY = 'manejai_remembered_email';

/** Identificador estável deste navegador (persistido em localStorage). */
export function getDeviceFingerprint(): string {
  let fingerprint = localStorage.getItem(FINGERPRINT_KEY);
  if (!fingerprint) {
    fingerprint = crypto.randomUUID();
    localStorage.setItem(FINGERPRINT_KEY, fingerprint);
  }
  return fingerprint;
}

export function getDeviceLabel(): string {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iPhone / iPad';
  if (/Android/i.test(ua)) return 'Android';
  if (/Mac/i.test(ua)) return 'Mac';
  if (/Windows/i.test(ua)) return 'Windows';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Navegador web';
}

export function getTrustDevicePreference(): boolean {
  return localStorage.getItem(TRUST_DEVICE_KEY) !== '0';
}

export function setTrustDevicePreference(trust: boolean): void {
  localStorage.setItem(TRUST_DEVICE_KEY, trust ? '1' : '0');
}

export function getRememberedEmail(): string | null {
  return localStorage.getItem(REMEMBERED_EMAIL_KEY);
}

export function setRememberedEmail(email: string): void {
  localStorage.setItem(REMEMBERED_EMAIL_KEY, email.trim().toLowerCase());
}

export function clearRememberedEmail(): void {
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
}
